<template>
  <div :class="['nt-richtext', getTheme]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'nt-richtext',
  props: {
    theme: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    getTheme() {
      return `nt-richtext--${this.theme}`
    }
  },
}
</script>

<style lang="scss" scoped>
  .nt-richtext {
    font-family: "Open Sans", sans-serif;
    font-size: 1.2em;
    line-height: 1.6em;
    letter-spacing: -1px;
    color: #3e3b37;
    text-decoration: none;

    &--small {
      font-size: 1rem;
    }
  }
</style>